import { ROLE_NAME } from 'enums';
import { PATHS } from 'types';

interface INavigationItem {
  path: PATHS;
  titleId: string;
}

/**
 * Single source of truth for the app's main navigation. Both the desktop
 * header (Navigation) and the mobile menu (NavigationMenu) render from this
 * list — only the styling differs.
 */
export function getNavigationItems(roleName: string | undefined): INavigationItem[] {
  const isMentee = roleName === ROLE_NAME.MENTEE;

  const items: INavigationItem[] = [];

  if (!isMentee) {
    items.push({ path: PATHS.DASHBOARD, titleId: 'navigation.dashboard' });
    items.push({ path: PATHS.COMPANY_MEMBERS, titleId: 'navigation.people' });
    items.push({
      path: PATHS.EXPERTISE_MANAGEMENT,
      titleId: 'navigation.expertise',
    });
    items.push({
      path: PATHS.KNOWLEDGE_AREA,
      titleId: 'navigation.knowledge-areas',
    });
  }

  return items;
}
